import React, {
  useContext,
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from 'react'
import { intCol, numCol } from '@integec/grid-tools/lib/cols'
// import { utilityReqHeader, unitHeader } from 'core/HeaderColTypeProps'
import {
  rowHeaderRender,
  getApiTargetInfo,
  // ExportComponent,
  sortStringArray,
  ExportComponent,
  exportDataComponent,
  getUnitCodeCauseCodeMapList,
  isValidYearRange,
} from 'core'
import Card97EditPrompt from 'card-data/component/card97/Card97EditAntd'
import { connect } from 'react-redux'
import R from 'ramda'
import SelectUnit from 'admin/component/unit-group/UnitGroupModal'
import {
  // getCard97,
  // deleteCard97,
  getSystemConfigurationInfo,
  // getUnitInfo,
  // getAmpCodeMgmtInfo,
  // getFailCodeMgmtInfo,
  getCard97Idx,
  // getCard97ExtensionSpec,
  getUnitGroup,
  getAdhocCausecodeGroups,
  postAdhocRptCausecodeGroup,
  postUnitGroup,
  getCauseCodeAll,
  deleteAdhocCauseCodeGroup,
} from 'api/pgads'

// import { headers as Card97Headers } from 'card-data/Card97Antd'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getCauseCodeMap,
  getUnits,
  getFailCode,
  getAmlificationCode,
  getPermitActions,
  getEnvConfig,
  getEventTypes,
  getUnitTypeCode,
  getCauseCodeOmcMap,
  getValidYearRange,
} from 'core/selectors'
import {
  Button,
  Input,
  message,
  Select,
  DatePicker,
  List,
  Tooltip,
  Switch,
  Modal,
} from 'antd'
// import CauseCodePrompt from './MultiCauseCode'
import moment from 'moment'
import Card97Headers, {
  CPSHeaders,
  APSCard97Headers,
  DukeFossileCard97Headers,
} from './EventDashboardHeaders'
import {
  DatePickerContext,
  ErrorContext,
  SpinContext,
  UnitSelectionContext,
} from 'context'
import { getChangeDateSelectionProps } from 'reports/dm/changeDateSelection'
import CauseCodePrompt, { generateCauseCodeKey } from 'card-data/MultiCauseCode'
import { Content, CriteriaRow, FullHeightSizer, Title } from 'core/screen-util'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import {
  card97TableCellRender,
  timeZoneList,
  unitCodeList,
  unitShortNameList,
} from 'card-data/Card97Antd'
import CustomUnitGroup from '../reports/components/SelectUnits'
import {
  APS_CLIENT,
  BROOKFIELD_CLIENT,
  CALPLINE_CLIENT,
  CLECO,
  CPS_CLIENT,
  DUKE_FHO,
  WEE_CLIENT,
  TVA_CLIENT,
  NYISO_CLIENT,
  COOP_CLIENT,
} from 'client'
import { retrieveEventDashboardApi } from './utils'
import { conCodeMap } from 'card-data/utils'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'

const EventDashboard = ({
  apiTargetInfo,
  unitNameMap,
  utilityNameMap,
  units,
  eventTypesAll,
  envConfig,
  ampCodeMap,
  failCodeMap,
  causeCodeMap,
  extraComponentList = [],
  extraCriteria = {},
  title = 'Event Dashboard',
  children,
  causeCodeOmcMap,
  ...props
}) => {
  const CLIENT = envConfig.clientId || 'INTEG'
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const { selectedUnits, setSelectedUnits } = useContext(UnitSelectionContext)
  const eventTypes = useMemo(
    _ => {
      if (
        CLIENT === BROOKFIELD_CLIENT ||
        CLIENT === TVA_CLIENT ||
        CLIENT === NYISO_CLIENT
      ) {
        return [
          ...eventTypesAll,
          { eventType: 'CO', description: 'Condensing' },
          { eventType: 'PU', description: 'Pumping' },
        ]
      } else return eventTypesAll
    },
    [CLIENT, eventTypesAll]
  )

  const [selectedRows, setSelectedRows] = useState([])
  const [card97Dominant, setCard97Dominant] = useState(false)
  const [unitCodeMap, setUnitCodeMap] = useState({})
  const [unitShortNameMap, setUnitShortNameMap] = useState({})
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [promptEdit, setPromptEdit] = useState(false)
  const [timeZoneMap, setTimeZoneMap] = useState({})

  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [data, setData] = useState({ CARD97: [] })
  const [dateSelectionType, setDateSelectionType] = useState(0)
  const [unitGroup, setUnitGroup] = useState([])

  const [selectedEventTypes, setSelectedEventTypes] = useState([])
  const [selectedUnitGroup, setSelectedUnitGroup] = useState('Custom')
  const [showUnitModal, setShowUnitModal] = useState({
    visible: false,
    selUnits: [],
  })
  const [showcustomUnitGroup, setShowCustomUnitGroup] = useState(false)

  const [causeCodeGroupMap, setCauseCodeGroupMap] = useState({})
  const [selectedCauseCodeName, setSelectedCauseCodeName] = useState()
  const [selectedCauseCodeNameText, setSelectedCauseCodeNameText] = useState()

  const [causeCode, setCauseCode] = useState({
    visible: false,
    causeCodeValues: [],
    causeCodeKeyValues: [],
    canSave: false,
  })

  const [causeCodeList, setCauseCodeList] = useState([])

  const openCustomUnitGroup = _ => setShowCustomUnitGroup(true)
  const onCauseCodeDialogClose = (selectedKeys, selectedValues) => {
    setCauseCode({
      visible: false,
      causeCodeKeyValues: selectedKeys,
      causeCodeValues: selectedValues,
      canSave: true,
    })
  }

  const onChangeCriteria = _ => {
    setData({ CARD97: [] })
  }

  // useEffect(
  //   _ => {
  //     setData({CARD97:[]})
  //   },
  //   [
  //     selectedCauseCodeName,
  //     selectedUnitGroup,
  //     selectedEventTypes,
  //     // selectedDateRangePicker,
  //   ]
  // )

  const onCausecodeSelectionChnage = name => {
    if (name === 'Custom') {
      setCauseCode({
        causeCodeValues: [],
        causeCodeKeyValues: [],
        canSave: false,
      })
      setSelectedCauseCodeName(name)
      setSelectedCauseCodeNameText('')
      onChangeCriteria()
      return
    }
    const causeList = causeCodeGroupMap[name].map(n => n.causecode)
    // const valueList = causeCodeList.filter(c => causeList.includes(c.causeCode))
    // ${cc.system}-${cc.component}-${cc.unitCode}-${cc.unitType}-${cc.isOMC}-${cc.causeCode}-${cc.description}
    const valueList = R.compose(
      R.uniqBy(c => c.causeCode),
      R.filter(c => causeList.includes(c.causeCode))
    )(causeCodeList)
    const keys = valueList.map(generateCauseCodeKey)
    setCauseCode({
      ...causeList,
      causeCodeValues: valueList,
      causeCodeKeyValues: keys,
      canSave: false,
    })
    setSelectedCauseCodeName(name)
    setSelectedCauseCodeNameText(name)
    onChangeCriteria()
  }

  const deleteCauseCodeGroup = _ => {
    if (selectedCauseCodeName && selectedCauseCodeName !== 'Custom') {
      Modal.confirm({
        title: 'Delete Data items Group?',
        content: selectedCauseCodeName,
        onOk() {
          deleteAdhocCauseCodeGroup(apiTargetInfo)(selectedCauseCodeName).fork(
            setError,
            _ => {
              message.success(
                `Data Item group "${selectedCauseCodeName}" deleted successfully`
              )
              loadCauseCodeGroup()

              setCauseCode({
                causeCodeValues: [],
                causeCodeKeyValues: [],
                canSave: false,
              })
              setSelectedCauseCodeName('Custom')
              setSelectedCauseCodeNameText('')
              onChangeCriteria()
            }
          )
        },
        onCancel() {},
      })
    } else {
      message.warning('Please, Select Cause code group to delete')
    }
  }

  const saveCauseCodeGroup = _ => {
    if (
      !selectedCauseCodeNameText ||
      selectedCauseCodeNameText.length <= 0 ||
      selectedCauseCodeNameText.trim().length <= 0
    ) {
      return message.warn('Please, Provide Cause group name')
    }
    if ((causeCode.causeCodeValues || []).length <= 0) {
      return message.warn('Please, Select Cause Code')
    }
    postAdhocRptCausecodeGroup(apiTargetInfo)(
      causeCode.causeCodeValues.map(c => ({
        templateName: selectedCauseCodeNameText,
        causecode: c.causeCode,
      }))
    ).fork(setError, _ => {
      message.info('CauseCode group saved')
      loadCauseCodeGroup()
      setSelectedCauseCodeName(selectedCauseCodeNameText)
      // setSelectedCauseCodeNameText(name)
      setCauseCode({ ...causeCode, canSave: false })
    })
  }

  // eslint-disable-next-line no-unused-vars
  const onCauseCodeTreeCancel = defaultExpandedKeys => {
    //  setCauseCode({ visible: false, causeCodeKeyValues: defaultExpandedKeys })
    setCauseCode({ ...causeCode, visible: false, canSave: false })
  }

  const reloadSelectedUnits = useCallback(
    grpUnits => {
      const unfilter = units.filter(u => grpUnits.includes(u.unitId))

      setSelectedUnits(unfilter)
    },
    [setSelectedUnits, units]
  )

  const changeUnitGroup = useCallback(
    pr => {
      const name = pr.name

      const groupName = name || selectedUnitGroup
      setSelectedUnitGroup(groupName)

      const grpUnits =
        pr.unitIdList ||
        (unitGroup.find(u => u.unitGroup === groupName) || {}).units ||
        []

      reloadSelectedUnits(grpUnits)
      onChangeCriteria()
    },
    [reloadSelectedUnits, selectedUnitGroup, unitGroup]
  )

  const setCustomUnitGroup = ({ selUnits }) => {
    setShowCustomUnitGroup(false)
    // const notCustom = unitGroup.filter(d => d.unitGroup !== 'Custom')
    const custom = {
      groupName: 'Custom',
      units: selUnits.map(u => u.unitId),
      effectiveDate: moment().format('YYYY-MM-DD'),
    }

    // setUnitGroup([...notCustom, custom])
    changeUnitGroup({ name: 'Custom', unitIdList: custom.units })
  }

  // its from groupunit
  // const deleteUniteGroup = _ => {
  //   if (selectedUnitGroup && selectedUnitGroup !== 'Custom') {
  //     Modal.confirm({
  //       title: 'Delete Data items Group?',
  //       content: selectedUnitGroup,
  //       onOk() {
  //         deleteAdhocDataItemGroup(apiTargetInfo)(selectedUnitGroup).fork(
  //           setError,
  //           _ => {
  //             message.success(
  //               `Data Item group "${selectedUnitGroup}" deleted successfully`
  //             )

  //             loadUnitGroup()
  //             setCustomUnitGroup({ selUnits: [] })
  //           }
  //         )
  //       },
  //       onCancel() {},
  //     })
  //   } else {
  //     message.warning('Please, Select Unit group to delete')
  //   }
  // }

  const openNewUnitGroup = _ => {
    setShowUnitModal({ visible: true, isNew: true })
  }

  const loadCauseCodeGroup = useCallback(
    _ => {
      getAdhocCausecodeGroups(apiTargetInfo).fork(setError, groupList => {
        const grouped = R.groupBy(r => r.templateName)(groupList)
        // grouped = { Custom: [], ...grouped }
        setCauseCodeGroupMap(grouped)
      })
    },
    [apiTargetInfo, setError]
  )
  const loadUnitGroup = useCallback(
    _ => {
      getUnitGroup(apiTargetInfo)(selectedDateRangePicker[1]).fork(
        setError,
        group => {
          setUnitGroup(group)
        }
      )
    },
    [apiTargetInfo, selectedDateRangePicker, setError]
  )

  useEffect(
    _ => {
      loadUnitGroup()
      loadCauseCodeGroup()
      getSystemConfigurationInfo(apiTargetInfo).fork(setError, d => {
        const dominantData = d.filter(
          s => s.key === 'DOMINANT_DERATE' && s.value === 'YES'
        )
        // setState({ card97Dominant: dominantData.length > 0 ? true : false, loading: false })
        setCard97Dominant(dominantData.length > 0)
        getCauseCodeAll(apiTargetInfo).fork(setError, setCauseCodeList)
      })
    },
    [apiTargetInfo, loadCauseCodeGroup, loadUnitGroup, setError]
  )

  useEffect(
    _ => {
      setTimeZoneMap(timeZoneList(units))
      setUnitCodeMap(unitCodeList(units))
      setUnitShortNameMap(unitShortNameList(units))
    },
    [units]
  )

  const changeDateSelectionType = dateSelectionType => {
    setDateSelectionType(dateSelectionType)
    const val = getChangeDateSelectionProps(
      dateSelectionType,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    setSelectedDateRagePicker([val.startDate, val.endDate])
    onChangeCriteria()
  }

  const retrieveData = _ => {
    if (selectedUnits.length === 0) {
      message.warning('Please, Select Unit')
      return
    }

    if (
      !isValidYearRange(
        props.validYearRange,
        selectedDateRangePicker[0],
        selectedDateRangePicker[1]
      )
    ) {
      return
    }

    const request = {
      startDate: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      endDate: selectedDateRangePicker[1].format('YYYY-MM-DD'),
      unitId: selectedUnits.map(u => u.unitId),
      eventTypeId:
        selectedEventTypes.length === 0
          ? eventTypes.map(e => e.eventType)
          : selectedEventTypes,
      causeCodeId: (causeCode.causeCodeValues || []).map(c => c.causeCode),
      ...extraCriteria,
    }
    setSpinning(true)
    retrieveEventDashboardApi(CLIENT)(apiTargetInfo)(request).fork(
      setError,
      data => {
        setSpinning(false)
        setData(data || { CARD97: [] })
      }
    )
  }

  const onView = _ => {
    setEditPromptvisible(true)
  }

  const clientHeaders = useMemo(
    _ => {
      if (CLIENT === CPS_CLIENT || CLIENT === CALPLINE_CLIENT) {
        return CPSHeaders
      } else if (CLIENT === APS_CLIENT) {
        return APSCard97Headers
      } else if (CLIENT === DUKE_FHO) {
        return DukeFossileCard97Headers
      } else if (CLIENT === WEE_CLIENT || CLIENT === CLECO) {
        const WEline = numCol({
          ident: 'line',
          display: 'Duration (HRS)',
        })
        return R.insert(8, WEline, Card97Headers)
      } else if (CLIENT === BROOKFIELD_CLIENT) {
        const BKFline = numCol({
          ident: 'line',
          display: 'Spill MHH',
        })

        return R.insert(9, BKFline, Card97Headers)
      } else if (CLIENT === COOP_CLIENT) {
        const WEline = intCol({
          ident: 'line',
          display: 'Event Group',
          dataGetter: ({ rowData }) =>
            rowData && rowData.extension
              ? rowData.extension.number1
              : undefined,
        })
        return R.insert(5, WEline, Card97Headers)
      }
      return Card97Headers
    },
    [CLIENT]
  )

  const filterHeaders = useMemo(
    _ => {
      let finalHeaders = []
      if (CLIENT === APS_CLIENT) finalHeaders = APSCard97Headers
      finalHeaders = card97Dominant
        ? clientHeaders
        : clientHeaders.filter(h => !(h.ident === 'ioCode'))

      const coc = intCol({
        ident: 'coc',
        display: 'COC',
        dataGetter: ({ rowData }) =>
          rowData && rowData.extension
            ? rowData.extension.eventTypeExternal
            : undefined,
      })

      finalHeaders = R.insert(12, coc, finalHeaders)

      return finalHeaders
    },
    [CLIENT, card97Dominant, clientHeaders]
  )

  const headerWithFormatter = useMemo(
    _ =>
      filterHeaders.map(header =>
        header.ident === 'utility'
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unit'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : header.ident === 'conCode'
          ? {
              ...header,
              ...toSelectionColProps(conCodeMap),
            }
          : header
      ),
    [filterHeaders, unitNameMap, utilityNameMap]
  )

  const selectionChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows)
  }

  const setEditPromptvisible = visible => setPromptEdit(visible)
  const GridRef = useRef()
  const [showSelection, setShowSelection] = useState(true)

  const getHeight = (children, height) => {
    const ht = children ? height / 2 - 10 : height
    // return ht < 200 ? 200 : ht
    return ht
  }

  const unitCodeCauseCodeMap = useMemo(
    _ => getUnitCodeCauseCodeMapList(causeCodeList),
    [causeCodeList]
  )

  return (
    <div>
      <CriteriaRow style={{ margin: '5px' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '200px 250px 200px 150px 150px 150px 150px',
            gap: '5px',
            width: '100%',
          }}
        >
          <Title>{title}</Title>
          <DatePicker.RangePicker
            style={{ marginLeft: '15px', width: '95%' }}
            allowClear={false}
            format="MM/DD/YYYY"
            value={selectedDateRangePicker}
            onChange={d => {
              setSelectedDateRagePicker(d)
              onChangeCriteria()
              // retrieve({ dates: d })
            }}
          />

          <Select
            defaultValue={0}
            value={dateSelectionType}
            onChange={changeDateSelectionType}
          >
            <Select.Option value={0}>Custom Select</Select.Option>
            <Select.Option value={1}>Current Month</Select.Option>
            <Select.Option value={2}>Previous Month</Select.Option>
            <Select.Option value={3}>Current Year</Select.Option>
            <Select.Option value={4}>Year To Date</Select.Option>
            <Select.Option value={5}>Month To Date</Select.Option>
            <Select.Option value={6}>Previous Year</Select.Option>
            <Select.Option value={7}>Year To Month</Select.Option>
            <Select.Option value={8}>Year To Last Month</Select.Option>
            <Select.Option value={9}>Trailing Twelve Month</Select.Option>
            <Select.Option value={10}>Complete Year</Select.Option>
            <Select.Option value={11}>First Quarter</Select.Option>
            <Select.Option value={12}>Second Quarter</Select.Option>
            <Select.Option value={13}>Third Quarter</Select.Option>
            <Select.Option value={14}>Fourth Quarter</Select.Option>
          </Select>
          <Button type="primary" onClick={retrieveData} icon="database">
            Retrieve
          </Button>
          <Switch
            style={{ justifySelf: 'center', alignSelf: 'center' }}
            placeholder="Select Unit(s)"
            checkedChildren="Hide Selection"
            unCheckedChildren="Show Selection"
            checked={showSelection}
            disabled={selectedUnits.length <= 0}
            onChange={cheked => {
              if (selectedUnits.length === 0) {
                message.warning('Please, Select Unit')
                return
              }
              setShowSelection(cheked)
            }}
          />

          <Input.Search
            placeholder="Filter"
            value={fuzzyFilter}
            style={{
              marginLeft: '10px',
              marginRight: '10px',
              justifySelf: 'end',
              width: '100%',
            }}
            onChange={e => setFuzzyFilter(e.target.value)}
          />
          <ExportComponent
            getData={_ =>
              exportDataComponent(
                GridRef,
                (data || {}).CARD97 || [],
                fuzzyFilter
              )
            }
            data={(data || {}).CARD97}
            headers={(headerWithFormatter || []).map(d => ({
              ...d,
              rowHeaderBackgroundColor: '#eee',
            }))}
            fileName={title}
            btnStyle={{ marginRight: '10px' }}
            disabled={(data || { CARD97: [] }).CARD97.length <= 0}
          />
        </div>
      </CriteriaRow>
      {showSelection && (
        <CriteriaRow
          style={{
            display: 'grid',
            gridTemplateColumns:
              extraComponentList.length > 0
                ? '1fr 1fr 1fr ' + extraComponentList.map(_ => '1fr').join(' ')
                : '1fr 1fr 1fr',
            gridTemplateRows: '160px',
            margin: '5px',
            gap: '5px',
          }}
        >
          <fieldset
            style={{ display: 'grid', gap: '5px', border: '1px solid black' }}
          >
            <legend style={{ width: '150px', marginBottom: '0px' }}>
              Unit Group
            </legend>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '70% 30%',
                gridColumnGap: '5px',
              }}
            >
              <Select
                style={{
                  width: '100%',
                  display: 'grid',
                  gridColumnEnd: 'span 1',
                }}
                onChange={name => changeUnitGroup({ name })}
                value={selectedUnitGroup}
              >
                <Select.Option key="Custom" value="Custom">
                  Custom
                </Select.Option>
                {sortStringArray(unitGroup.map(ug => ug.unitGroup)).map(ug => (
                  <Select.Option key={ug} value={ug}>
                    {ug}
                  </Select.Option>
                ))}
              </Select>
              <div style={{ display: 'flex', gap: '5px' }}>
                <Tooltip title="Update Group" placement="bottomLeft">
                  <Button
                    style={{ justifyContent: 'end' }}
                    disabled={
                      selectedUnitGroup.length === 0 ||
                      selectedUnitGroup === 'Custom'
                    }
                    onClick={_ => setShowUnitModal({ visible: true })}
                    icon="link"
                  />
                </Tooltip>
                <Tooltip title="New Group" placement="bottomLeft">
                  <Button
                    onClick={openNewUnitGroup}
                    icon="plus-circle"
                    style={{ justifyContent: 'end' }}
                  />
                </Tooltip>
                <Tooltip title="Custom" placement="bottomLeft">
                  <Button
                    onClick={openCustomUnitGroup}
                    icon="bars"
                    style={{ justifyContent: 'end' }}
                  />
                </Tooltip>
                {/* <Tooltip title="Delete Group" placement="bottomLeft">
                  <Button
                    onClick={deleteUniteGroup}
                    icon="delete"
                    disabled={
                      selectedUnitGroup === 'Custom' || !selectedUnitGroup
                    }
                  />
                </Tooltip> */}
              </div>
            </div>
            <div style={{ overflowY: 'scroll', height: '100px' }}>
              <List
                size="small"
                bordered
                dataSource={selectedUnits}
                rowKey={ex => ex.unitId}
                renderItem={ex => {
                  return <List.Item>{ex.unitName}</List.Item>
                }}
              />
            </div>
          </fieldset>
          <fieldset
            style={{
              display: 'grid',
              gridRowGap: '5px',
              border: '1px solid black',
            }}
          >
            <legend style={{ width: '150px', marginBottom: '0px' }}>
              Cause Code
            </legend>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '80% 20%',
                gridGap: '5px',
              }}
            >
              <Select
                style={{ width: '100%' }}
                value={selectedCauseCodeName}
                onChange={onCausecodeSelectionChnage}
              >
                <Select.Option key="Custom" value="Custom">
                  Custom
                </Select.Option>
                {sortStringArray(Object.keys(causeCodeGroupMap)).map(k => (
                  <Select.Option key={k} value={k}>
                    {k}
                  </Select.Option>
                ))}
              </Select>
              <div style={{ display: 'flex', gap: '5px' }}>
                <Tooltip title="Open Dialog" placement="bottomLeft">
                  <Button
                    onClick={_ => setCauseCode({ ...causeCode, visible: true })}
                    icon="link"
                  />
                </Tooltip>
                <Tooltip title="Delete Group" placement="bottomLeft">
                  <Button
                    onClick={deleteCauseCodeGroup}
                    icon="delete"
                    disabled={
                      selectedCauseCodeName === 'Custom' ||
                      !selectedCauseCodeName
                    }
                  />
                </Tooltip>
              </div>
              {causeCode.canSave && (
                <Tooltip title="New Group / update" placement="bottomLeft">
                  <Input
                    value={selectedCauseCodeNameText}
                    onChange={e => setSelectedCauseCodeNameText(e.target.value)}
                    disabled={!causeCode.canSave}
                  />
                </Tooltip>
              )}
              {causeCode.canSave && (
                <Tooltip title="Save" placement="bottomLeft">
                  <Button
                    onClick={saveCauseCodeGroup}
                    icon="save"
                    disabled={!causeCode.canSave}
                  />
                </Tooltip>
              )}
            </div>

            <div
              style={{
                overflowY: 'auto',
                height: causeCode.canSave ? '80px' : '100px',
              }}
            >
              <List
                // style={{ height: '100px' }}
                size="small"
                bordered
                dataSource={causeCode.causeCodeValues || []}
                renderItem={ex => (
                  <List.Item>
                    {ex.causeCode}-{ex.description}
                  </List.Item>
                )}
              />
            </div>
          </fieldset>
          <fieldset
            style={{
              display: 'grid',
              gridTemplateRows: 'min-content auto',
              gridRowGap: '5px',
              gap: '5px',
              border: '1px solid black',
            }}
          >
            <legend style={{ width: '150px', marginBottom: '0px' }}>
              Event Type
            </legend>
            <div
              style={{
                gap: '5px',
                display: 'grid',
                gridTemplateColumns: 'auto auto auto',
                justifyContent: 'end',
              }}
            >
              <Button
                type="primary"
                onClick={_ => {
                  setSelectedEventTypes(eventTypes.map(e => e.eventType))
                  onChangeCriteria()
                }}
              >
                All Select
              </Button>
              <Button
                onClick={_ => {
                  setSelectedEventTypes([])
                  onChangeCriteria()
                }}
              >
                Clear All
              </Button>
            </div>
            <div style={{ height: '100px', overflowY: 'auto' }}>
              <Select
                mode="multiple"
                style={{ height: '100%', width: '100%', display: 'grid' }}
                onChange={ev => {
                  setSelectedEventTypes(ev)
                  onChangeCriteria()
                }}
                value={selectedEventTypes}
              >
                {eventTypes.map(e => (
                  <Select.Option key={e.eventType} value={e.eventType}>
                    {e.eventType}-{e.description}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </fieldset>
          {extraComponentList}
        </CriteriaRow>
      )}
      <FullHeightSizer heightOffset={showSelection ? 400 : 200}>
        {({ height, width }) => (
          <Content style={{ height: height, width }}>
            <div
              style={{
                display: 'grid',
                gridTemplateRows: children
                  ? height / 2 - 20 + 'px'
                  : getHeight(children, height) + 'px',
                // gridTemplateRows: children
                //   ? (height / 2 - 50 < 400 ? 400 : height / 2 - 50) + 'px'
                //   : height - 50 + 'px',
                rowGap: '10px',
                width: width - 50 + 'px',
              }}
            >
              <Grid
                ref={GridRef}
                sortEnabled
                data={(data || {}).CARD97}
                headers={headerWithFormatter}
                altBy={u => u.unit}
                altBgColor="#ebebeb"
                // onEditInfoChange={info => editRow(info)}
                // editInfo={editInfo}
                render={virtualizedGridRenderer({
                  autoFixColByKey: false,
                  rowHeaderRender,
                  // height: children ? height / 2 - 50 : height - 50,
                  height: getHeight(children, height) - 20,
                  // height: 400,
                  width: width - 50,
                  cellRender: card97TableCellRender({
                    onView,
                    causeCodeOmcMap,
                    CLIENT,
                  }),
                })}
                fuzzyFilter={fuzzyFilter}
                isEditable={false}
                onSelectionChange={rows => {
                  selectionChange(rows)
                }}
                selectionMode="single"
                selectionType="row"
                initialSortOptions={headerWithFormatter}
                // initialSortOptions={[
                //   utilityReqHeader,
                //   unitHeader,
                //   { ident: 'year', sortOrder: 'asc' },
                //   { ident: 'eventStart', sortOrder: 'asc' },
                //   { ident: 'eventEnd', sortOrder: 'asc' },
                //   // { ident: 'year', sortOrder: 'asc' },
                //   { ident: 'eventNum', sortOrder: 'asc' },
                //   // { ident: 'eventIdx', sortOrder: 'asc' },
                // ]}
              />

              {children &&
                children({
                  // onChangeCriteria: onCriteriaChange,
                  height: height,
                  firstHeight: getHeight(children, height),
                  width,
                  setData,
                  data,
                  onChangeCriteria,
                  fuzzyFilter,
                })}
            </div>
          </Content>
        )}
      </FullHeightSizer>

      {promptEdit && (
        <Card97EditPrompt
          CLIENT={CLIENT}
          key="card97editprompt"
          retrieveData={retrieveData}
          mode="V"
          setMode={_ => 'V'}
          targetInfo={apiTargetInfo}
          rowData={selectedRows[0]}
          utilityNameMap={utilityNameMap}
          unitNameMap={unitNameMap}
          criteriaUnit={
            selectedUnits.length === 1 ? selectedUnits[0].unitId : ''
          }
          timeZoneMap={timeZoneMap}
          card97Dominant={card97Dominant}
          unitsList={units}
          ampCodeMap={ampCodeMap}
          failCodeMap={failCodeMap}
          unitCodeMap={unitCodeMap}
          unitShortNameMap={unitShortNameMap}
          getCardIdx={getCard97Idx(apiTargetInfo)}
          idxData={[]}
          causeCodeMap={causeCodeMap}
          promptEdit={promptEdit}
          setEditPromptvisible={setEditPromptvisible}
          headers={headerWithFormatter}
          apiTargetInfo={apiTargetInfo}
          causeCodeList={causeCodeList}
          unitCodeCauseCodeMap={unitCodeCauseCodeMap}
          // extendedCard={ps => <DomNucExtension {...ps} />}
        />
      )}

      {showUnitModal.visible && (
        <SelectUnit
          list={unitGroup}
          updateTask={postUnitGroup(apiTargetInfo)}
          createTask={postUnitGroup(apiTargetInfo)}
          availableUnits={units}
          utilityNameMap={utilityNameMap}
          isNew={false}
          // units={
          //   (unitGroup.find(u => u.unitGroup === selectedUnitGroup) || {})
          //     .units || []
          // }
          data={{
            ...(unitGroup.find(u => u.unitGroup === selectedUnitGroup) || {}),
            isNew: selectedUnitGroup === 'Custom' || showUnitModal.isNew,
          }}
          hide={finalData => {
            setShowUnitModal({ ...showUnitModal, visible: false })
            loadUnitGroup(true)

            if (finalData) {
              message.info('Unit Group saved')
              if (!finalData.isNew) {
                reloadSelectedUnits(finalData.units)
                setSelectedUnitGroup(finalData.unitGroup)
              }
              if (finalData.isNew)
                if (
                  moment(finalData.effectiveDate).isSameOrBefore(
                    selectedDateRangePicker[1]
                  )
                ) {
                  // isnew =true
                  reloadSelectedUnits(finalData.units)
                  setSelectedUnitGroup(finalData.unitGroup)
                } else {
                  message.warning('Effective date is not in range')
                }
            }
          }}
          title="Select Units"
          visible={showUnitModal.visible}
          // onOk={data => {
          //   message.info('Unit Group Saved')
          //   setShowUnitModal({ selUnits: data.selUnits, visible: false })
          //   // loadUnitGroup()
          // }}
          // modalClose={_ =>
          //   setShowUnitModal({ ...showUnitModal, visible: false })
          // }
        />
      )}
      {showcustomUnitGroup && (
        <CustomUnitGroup
          visible={showcustomUnitGroup}
          onCancel={_ => setShowCustomUnitGroup(false)}
          modalClose={_ => setShowCustomUnitGroup(false)}
          onOk={setCustomUnitGroup}
        />
      )}
      <CauseCodePrompt
        // unitCodes={['CG', 'CC']}
        unitCodes={Object.keys(props.unitTypeCodes)}
        key="causecodeprompt"
        // style={{ ...inlineStyle }}
        // checkable={false}
        visibleDialog={causeCode.visible}
        onDialogClose={onCauseCodeDialogClose}
        onCancelAction={onCauseCodeTreeCancel}
        // defaultExpandedKeys={
        //   this.state.causeCode ? this.state.causeCode.selectedKeys : []
        // }
        defaultExpandedKeys={causeCode.causeCodeKeyValues}
        defaultCheckedKeys={causeCode.causeCodeKeyValues}
        // unitCode={this.state.unitCodeMap && this.state.unitCodeMap[selectedUnits[0]]}
        // unitCode={
        //   this.state.unitCodeMap &&
        //   this.state.unitCodeMap[
        //     selectedUnits && selectedUnits[0] ? selectedUnits[0].unitId : 'CC'
        //   ]
        // }
        multiple
        checkable
        selectable={false}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  causeCodeMap: getCauseCodeMap(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  units: getUnits(state),
  ampCodeMap: getAmlificationCode(state),
  failCodeMap: getFailCode(state),
  eventTypesAll: getEventTypes(state),
  unitTypeCodes: getUnitTypeCode(state),
  causeCodeOmcMap: getCauseCodeOmcMap(state),
  validYearRange: getValidYearRange(state),
})
export default connect(mapStateToProps)(EventDashboard)
